"use strict";

exports.__esModule = true;
exports.CycleList = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactWindow = require("react-window");
var _CycleListItem = require("./CycleListItem");
var _UiDesignContext = require("../../Theme/UiDesign/UiDesignContext");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a selectable list of cycles.
 */
var CycleList = exports.CycleList = /*#__PURE__*/function (_Component) {
  function CycleList() {
    var _this;
    _this = _Component.call(this) || this;
    _this.state = {
      isCurrentSelected: false
    };
    _this.handleClick = function (classification, event) {
      var _this$props = _this.props,
        selected = _this$props.selected,
        onSelectionChanged = _this$props.onSelectionChanged,
        values = _this$props.values;
      var updated = [];
      if (_this.startRangeOfShiftKey === classification || _this.endRangeOfShiftKey === classification) {
        _this.numberOfShiftKeyClicked--;
      }
      if (event.shiftKey) {
        _this.numberOfShiftKeyClicked++;
        if (_this.numberOfShiftKeyClicked === 1) {
          _this.startRangeOfShiftKey = classification;
          updated.push(classification.interval);
        } else if (_this.numberOfShiftKeyClicked === 2) {
          _this.endRangeOfShiftKey = classification;
          if (_this.startRangeOfShiftKey.interval.startMillis > _this.endRangeOfShiftKey.interval.startMillis) {
            var tempValue = _this.startRangeOfShiftKey;
            _this.startRangeOfShiftKey = _this.endRangeOfShiftKey;
            _this.endRangeOfShiftKey = tempValue;
          }
          var foundStartRangeOfShiftElement = false;
          var foundEndRangeOfShiftElement = false;
          values.map(function (element) {
            if (foundStartRangeOfShiftElement && !foundEndRangeOfShiftElement) {
              updated.push(element.interval);
            } else if (element.interval.startMillis === _this.startRangeOfShiftKey.interval.startMillis && element.interval.endMillis === _this.startRangeOfShiftKey.interval.endMillis) {
              foundStartRangeOfShiftElement = true;
              updated.push(element.interval);
            }
            if (element.interval.startMillis === _this.endRangeOfShiftKey.interval.startMillis && element.interval.endMillis === _this.endRangeOfShiftKey.interval.endMillis) {
              foundEndRangeOfShiftElement = true;
              updated.push(element.interval);
            }
          });
          if (!foundEndRangeOfShiftElement) {
            updated.splice(0, updated.length);
          }
          _this.numberOfShiftKeyClicked = 0;
          _this.startRangeOfShiftKey = {};
          _this.endRangeOfShiftKey = {};
        }
      } else {
        var shouldAppend = true;
        for (var i = 0; i < selected.length; i++) {
          var interval = selected[i];
          if (classification.interval.startMillis === interval.startMillis && classification.interval.endMillis === interval.endMillis) {
            shouldAppend = false;
          } else {
            updated.push(interval);
          }
        }
        if (shouldAppend) {
          updated.push(classification.interval);
        }
      }
      onSelectionChanged(updated);
    };
    _this.numberOfShiftKeyClicked = 0;
    _this.startRangeOfShiftKey = {};
    _this.endRangeOfShiftKey = {};
    return _this;
  }
  _inheritsLoose(CycleList, _Component);
  CycleList.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (!prevState.isCurrentSelected) {
      var data = props.data,
        selected = props.selected,
        onSelectionChanged = props.onSelectionChanged;
      if (!selected.length) {
        var currentCycle = data && data[data.length - 1];
        if (currentCycle) {
          onSelectionChanged([currentCycle.interval]);
          return {
            isCurrentSelected: true
          };
        }
      }
    }
    return prevState;
  };
  var _proto = CycleList.prototype;
  _proto.isSelected = function isSelected(input) {
    var selected = this.props.selected;
    for (var i = 0; i < selected.length; i++) {
      var interval = selected[i];
      if (input.startMillis === interval.startMillis && input.endMillis === interval.endMillis) {
        return true;
      }
    }
    return false;
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props2 = this.props,
      width = _this$props2.width,
      height = _this$props2.height,
      values = _this$props2.values,
      data = _this$props2.data,
      plantStateActivities = _this$props2.plantStateActivities;
    return /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      width: width,
      height: height,
      itemCount: values.length,
      itemSize: this.context && this.context.modern ? 96 : 80,
      overscanCount: 2
    }, function (_ref) {
      var index = _ref.index,
        style = _ref.style;
      return /*#__PURE__*/_react["default"].createElement(_CycleListItem.CycleListItem, {
        data: data,
        key: index,
        style: style,
        classification: values[values.length - (index + 1)],
        plantStateActivities: plantStateActivities,
        onClick: _this2.handleClick,
        isSelected: _this2.isSelected(values[values.length - (index + 1)].interval)
      });
    });
  };
  return CycleList;
}(_react.Component);
CycleList.contextType = _UiDesignContext.UiDesignContext;
CycleList.defaultProps = {
  now: undefined,
  selected: Object.freeze([])
};